import { InitConfiguration } from 'model/init-config';

export const config: InitConfiguration = {
	override: {
		'plugins/lightbox/jquery.lightbox': 'customer/plugins/jquery.lightbox',
	},
};
